import React from "react";
import IframePage from "./IframePage";
import "../../../css/BoletinOficial/declaraciones.css";

const Declaraciones = () => (
    <IframePage
      title="DECLARACIONES"
      description="Un gobierno abierto y transparente que pone a disposición de los ciudadanos información relevante para promover mayor participación y cercanía."
      iframeUrl="https://ciudaddeoliva.gov.ar/boletin-oficial/declaraciones"
      classPrefix="declaraciones"
    />
    
);

export default Declaraciones;
